import React from 'react';
import { TooltipIcon } from '../Tooltip';
import { Box, Link, Text } from '../core';

export const Disclaimer = (): JSX.Element | null => {
  return (
    <Box mt={1}>
      <Link
        sx={{ alignText: 'right', textDecoration: 'none' }}
        target="_blank"
        rel="noopener noreferrer"
        href="https://docs.scion.finance/security/investment-risks"
      >
        <Text variant="info" mt={1} sx={{ color: 'secondary' }}>
          <TooltipIcon /> Read about the{' '}
          <Text sx={{ textDecoration: 'underline' }}>risks</Text> inherent to
          DeFi before depositing funds.
        </Text>
      </Link>{' '}
    </Box>
  );
};
